import {disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks} from 'body-scroll-lock';


let userPhone,
    userMail,
    userLogin,
    userPass,
    userKey;

function openRegModal() {
  let html = '<form id="regModal" class="modal modal_reg" action="/reg">\n' +
      '  <div class="modal__body">\n' +
      '    <button type="button" class="modal__close"><img src="/img/close.svg" alt=""></button>\n' +
      '    <h3>Регистрация</h3>\n' +
      '    <label class="animate"><img src="/img/user_form.svg" alt=""><div></div><input id="login" name="login" type="text" placeholder="Логин" value="' + (userLogin ? userLogin : '') + '"></label>\n' +
      '    <label class="animate"><img src="/img/mail_form.svg" alt=""><div></div><input id="mail" inputmode="email" type="text" name="email" autocomplete="email" placeholder="Почта" value="' + (userMail ? userMail : '') + '"></label>\n' +
      '    <label class="animate pass-mini"><img src="/img/lock_form.svg" alt=""><div></div><input name="password" autocomplete="new-password" id="pass" type="text" placeholder="Пароль" value="' + (userPass ? userPass : '') + '"></label>\n' +
      '    <label class="animate pass-mini"><img src="/img/lock_form.svg" alt=""><div></div><input name="re-password" autocomplete="new-password" type="text" placeholder="Ещё раз"></label>\n' +
      '    <label class="animate"><img src="/img/phone_form.svg" alt=""><div></div><div class="selector">\n' +
      '                <input type="hidden" name="phone_code" value="+7">\n' +
      '                <button class="selector__button" type="button">+7</button>\n' +
      '                <div class="selector__items">\n' +
      '                  <button class="selector__item d-none" value="+7" type="button">+7</button>\n' +
      '                  <button class="selector__item" value="+380" type="button">+1</button>\n' +
      '                  <button class="selector__item" value="+380" type="button">+380</button>\n' +
      '                  <button class="selector__item" value="+380" type="button">+375</button>\n' +
      '                </div>\n' +
      '              </div><input id="phone" name="phone" type="tel" placeholder="Телефон" value="' + (userPhone ? userPhone : '') + '"></label>\n' +
      '    <label class="animate"><img src="/img/key_form.svg" alt=""><div></div><input name="keyword" type="text" id="key" placeholder="Слово ключ" value="' + (userKey ? userKey : '') + '"></label>\n' +
      '    <div class="captcha-field-wrapper"><img src="/captcha.php" alt="" class="captcha-field-wrapper__captcha">' +
      '    <label class="animate"><input name="captcha" type="text" placeholder="Текст с картинки"></label></div>\n' +
      '    <button class="button" type="submit"><span>Создать аккаунт</span></button>\n' +
      '    <p class="modal__footer-txt">Нажимая кнопку ”Создать аккаунт” вы соглашаетесь с условиями <a href="/agreement" target="_blank">пользовательского соглашения</a></p>\n' +
      '  </div>\n' +
      '</form>';
  document.body.insertAdjacentHTML('beforeEnd', html);
  animateLabel(document.querySelectorAll('label.animate'));
  document.querySelector('#regModal').style.opacity = 1;
  disableBodyScroll();
  document.querySelectorAll('#regModal .selector').forEach(selector => {
    let input = selector.querySelector('input'),
        items = selector.querySelectorAll('.selector__item');
    selector.querySelector('.selector__button').addEventListener('click', () => {
      selector.classList.toggle('open')
    });
    items.forEach(item => {
      item.addEventListener('click', e => {
        e.preventDefault();
        selector.querySelector('.selector__button').innerHTML = e.target.innerHTML;
        selector.querySelector('.selector__item.d-none').classList.remove('d-none');
        e.target.classList.add('d-none');
        input.value = e.target.value;
        selector.classList.remove('open');
      })
    })
  });
  document.querySelector('#regModal #login').addEventListener('input', e => {
    userLogin = e.target.value;
  });
  document.querySelector('#regModal #mail').addEventListener('input', e => {
    userMail = e.target.value;
  });
  document.querySelector('#regModal #phone').addEventListener('input', e => {
    userPhone = e.target.value;
  });
  document.querySelector('#regModal #pass').addEventListener('input', e => {
    userPass = e.target.value;
  });
  document.querySelector('#regModal #key').addEventListener('input', e => {
    userKey = e.target.value;
  });
  document.querySelectorAll('#regModal .modal__close, #regModal .modal__close *').forEach(item => {
    item.addEventListener('click', () => {
      document.querySelector('#regModal').remove();
      clearAllBodyScrollLocks();
    })
  });
  let regForm = document.querySelector('#regModal');
  regForm && regForm.addEventListener('submit', (e) => {
    e.preventDefault();
    let formActionUrl = new URL(regForm.getAttribute('action'), document.location.origin);
    formActionUrl.searchParams.append('ajax', '1');
    regForm.classList.add('loading');
    let data = new FormData(regForm);

    fetch(formActionUrl.toString(), {
      method: 'post',
      body: data
    })
        .then(r => r.json())
        .then(response => {
          if (response.success) {
            document.location.href = response.redirect;
          } else {
            regForm.classList.add('error');
            setTimeout(() => {
              regForm.classList.remove('error');
            }, 1000);

            // reload captcha
            let captcha = document.querySelector('.captcha-field-wrapper__captcha');
            if (captcha) {
              captcha.setAttribute('src', '/captcha.php?' + (new Date).getTime());
            }
            if(document.querySelector('#regModal input[name=captcha]')) {
              document.querySelector('#regModal input[name=captcha]').value = '';
            }

            for (let error in response.errors) {
              if (response.errors[error]) {
                if (error == 'ip') {
                  alert(response.errors[error]);
                }
                let inputWithError = document.querySelector('#regModal input[name=' + error + ']');
                if (inputWithError) {
                  inputWithError.closest('label').insertAdjacentHTML('beforeEnd', '<span class="error-message">' + response.errors[error] + '</span>');
                  inputWithError.addEventListener('input', () => {
                    let errorMessage = inputWithError.closest('label').querySelector('.error-message');
                    if (errorMessage) {
                      errorMessage.remove();
                    }
                  });
                }
              }
            }
          }
        })
        .finally(() => {
          regForm.classList.remove('loading');
        });
  });

}

document.querySelectorAll('[data-modal=reg]').forEach(e => {
  e.addEventListener('click', e => {
    e.preventDefault();
    openRegModal();
  });
});

function openLoginModal() {
  let html = '<form id="loginModal" class="modal modal_login" action="/auth">\n' +
      '  <div class="modal__body">\n' +
      '    <button class="modal__close" type="button"><img src="/img/close.svg" alt=""></button>\n' +
      '    <h3>Вход</h3>\n' +
      '    <label class="animate"><img src="/img/user_form.svg" alt=""><div></div><input required id="login" name="data" type="text" placeholder="Почта/Логин" value="' + (userMail ? userMail : userLogin ? userLogin : '') + '"></label>\n' +
      '    <label class="animate"><img src="/img/lock_form.svg" alt=""><div></div><input required id="pass" name="password" autocomplete="urrent-password" type="password" placeholder="Пароль" value="' + (userPass ? userPass : '') + '"></label>\n' +
      '    <a class="forgot-password" href="#" data-modal="recovery">Забыли пароль?</a>\n' +
      '    <button class="button" type="submit"><span>Вход</span></button>\n' +
      '    <p class="modal__footer-txt">Всё ещё не имеете аккаунта? <a href="#" data-modal="reg">Зарегистрируйтесь!</a></p>\n' +
      '  </div>\n' +
      '</form>';
  document.body.insertAdjacentHTML('beforeEnd', html);
  document.querySelector('#loginModal').style.opacity = 1;
  disableBodyScroll();
  document.querySelector('#loginModal #login').addEventListener('input', e => {
    if (String(e.target.value).includes('@')) {
      userLogin = '';
      userMail = e.target.value;
    } else {
      userLogin = e.target.value;
    }
  });
  document.querySelector('#loginModal #pass').addEventListener('input', e => {
    userPass = e.target.value;
  });
  document.querySelectorAll('#loginModal .modal__close, #regModal .modal__close *').forEach(item => {
    item.addEventListener('click', () => {
      document.querySelector('#loginModal').remove();
      clearAllBodyScrollLocks();

      let url = new URLSearchParams(document.location.search);

      if (url.has('auth')) {
        url.delete('auth');
        history.replaceState(null, null, '/' + url.toString());
      }
    })
  });

  let loginForm = document.querySelector('#loginModal');
  loginForm && loginForm.addEventListener('submit', (e) => {
    e.preventDefault();
    let formActionUrl = new URL(loginForm.getAttribute('action'), document.location.origin);
    formActionUrl.searchParams.append('ajax', '1');
    loginForm.classList.add('loading');
    let data = new FormData(loginForm);

    if (!data.get('data').length || !data.get('password').length) {
      loginForm.classList.add('error');
      setTimeout(() => {
        loginForm.classList.remove('error');
      }, 1000);
      return;
    }

    fetch(formActionUrl.toString(), {
      method: 'post',
      body: data
    })
        .then(r => r.json())
        .then(response => {
          if (response.success) {
            document.location.href = response.redirect;
          } else {
            loginForm.classList.add('error');
            loginForm.querySelector('#pass').closest('label').insertAdjacentHTML('beforeEnd', '<span class="error-message">Неверный логин или пароль</span>');
            loginForm.querySelectorAll('input').forEach(item => {
              item.addEventListener('input', () => {
                loginForm.querySelector('#pass').closest('label').querySelector('.error-message').remove();
              });
            });
            setTimeout(() => {
              loginForm.classList.remove('error');
            }, 1000)
          }
        })
        .finally(() => {
          loginForm.classList.remove('loading');
        });
  });

  document.querySelector('#loginModal [data-modal="reg"]').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('#loginModal').remove();
    clearAllBodyScrollLocks();
    openRegModal();
  });

  document.querySelector('#loginModal [data-modal="recovery"]').addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('#loginModal').remove();
    clearAllBodyScrollLocks();
    openRecoveryModal();
  });
}

document.querySelectorAll('[data-modal=login]').forEach(e => {
  e.addEventListener('click', e => {
    e.preventDefault();
    openLoginModal();
  })
});

(function () {
  let url = new URLSearchParams(document.location.search);

  if (url.has('auth')) {
    if (!document.querySelector('body').classList.contains('authenticated')) {
      openLoginModal();
    } else {
      url.delete('auth');
      history.replaceState(null, null, '/' + url.toString());
    }
  }
})();


function openRecoveryModal() {
  let html = '<form id="recoveryModal" class="modal modal_recovery" action="/recovery" method="post">\n' +
      '  <div class="modal__body">\n' +
      '    <button class="modal__close" type="button"><img src="/img/close.svg" alt=""></button>\n' +
      '    <h3>Восстановление пароля</h3>\n' +
      '    <label class="animate"><img src="/img/user_form.svg" alt=""><div></div><input required id="login" name="email" type="text" placeholder="Почта/Логин" value="' + (userMail ? userMail : userLogin ? userLogin : '') + '"></label>\n' +
      '    <button class="button" type="submit"><span>Восстановить</span></button>\n' +
      '  </div>\n' +
      '</form>';
  document.body.insertAdjacentHTML('beforeEnd', html);
  document.querySelector('#recoveryModal').style.opacity = 1;
  disableBodyScroll();
  document.querySelector('#recoveryModal #login').addEventListener('input', e => {
    if (String(e.target.value).includes('@')) {
      userLogin = '';
      userMail = e.target.value;
    } else {
      userLogin = e.target.value;
    }
  });
  document.querySelectorAll('#recoveryModal .modal__close, #recoveryModal .modal__close *').forEach(item => {
    item.addEventListener('click', () => {
      document.querySelector('#recoveryModal').remove();
      clearAllBodyScrollLocks();
      let url = new URLSearchParams(document.location.search);

      if (url.has('recovery')) {
        url.delete('recovery');
        history.replaceState(null, null, '/' + url.toString());
      }
    })
  });
}

(function () {
  let url = new URLSearchParams(document.location.search);

  if (url.has('recovery')) {
    openRecoveryModal();
  }
})();
